import { render, staticRenderFns } from "./ProductStockClose.vue?vue&type=template&id=7c010822&"
import script from "./ProductStockClose.vue?vue&type=script&lang=js&"
export * from "./ProductStockClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports